import converter from '../../../utils/converter';
import {
    ATOMIC_FRAME_REPORT_ID,
    BLE_ATOMIC_FRAME_HEADER,
    BLE_EXTENDED_FRAME_HEADERS,
    EXTENDED_FRAME_SIZE,
    NETWORK_LAYER_SIZE,
    SCP_BYTES,
    SEGMENTED_FRAME_NETWORK_LAYER_SIZE,
    SEGMENTED_FRAME_REPORT_ID,
} from '../scpConsts';
import {scpUtils} from '../scpUtils';

const isSegmentedFrameReportId = (reportId) => {
    const result = reportId.toString() === SEGMENTED_FRAME_REPORT_ID;

    return result;
};

const isExtendedFrame = (frame) => {
    const isExtended = !frame.startsWith(ATOMIC_FRAME_REPORT_ID);

    return isExtended;
};

const isExtendedSegmentedFrame = (frame) => {
    const isExtended = isExtendedFrame(frame);

    if (!isExtended) return false;

    const isSegmentedFrame = frame.length > NETWORK_LAYER_SIZE * 2;

    return isSegmentedFrame;
};

const getNetworkLayerSize = (frame) => {
    const size = frame.length / 2;

    return size;
};

const segmentFrame = (frame) => {
    const segments = frame.match(new RegExp('.{1,' + SEGMENTED_FRAME_NETWORK_LAYER_SIZE * 2 + '}', 'g'));
    const segmentsCount = segments.length;

    const fullSegments = segments.map((segment, i) => {
        const result = addHeadersToSegment(segment, i, segmentsCount);

        return result;
    });

    return fullSegments;
};

const addHeadersToSegment = (segment, segmentIndex, segmentsCount) => {
    const segmentId = getSegmentIdByte(segmentIndex, segmentsCount);
    const segmentWithIdByte = segmentId + segment;

    const size = getNetworkLayerSize(segmentWithIdByte);
    const sizeHex = converter.dec2hex(size);

    const segmentWithHeaders = `${SEGMENTED_FRAME_REPORT_ID}${sizeHex}${segmentWithIdByte}`;
    const fullSegment = segmentWithHeaders.padEnd(EXTENDED_FRAME_SIZE * 2, '0');

    return fullSegment;
};

const addHeadersToAtomicFrame = (segment) => {
    const size = getNetworkLayerSize(segment);
    const sizeHex = converter.dec2hex(size);

    const segmentWithHeaders = `${ATOMIC_FRAME_REPORT_ID}${sizeHex}${segment}`;
    const fullSegment = segmentWithHeaders.padEnd(EXTENDED_FRAME_SIZE * 2, '0');

    return fullSegment;
};

const getSegmentIdByte = (current, total) => {
    let segmentId = converter.hex2binString(total - 1 - current);
    const isInitial = current === 0;

    if (isInitial) {
        // Set first bit to '1' if it is first segment
        segmentId = segmentId.replace('0', '1');
    }

    const segmentIdHex = converter.bin2hex(segmentId);

    return segmentIdHex;
};

const getSegmentIdFromSegment = (frame) => {
    const segmentIdByte = scpUtils.getDataFromFrame(frame, SCP_BYTES.EXTENDED_FRAME_SEGMENT_ID);
    let segmentIdByteBin = converter.hex2binString(segmentIdByte);
    const isInitial = segmentIdByteBin.charAt(0) === '1';

    if (isInitial) {
        // Set first bit to '0' if it is first segment
        segmentIdByteBin = segmentIdByteBin.replace('1', '0');
    }

    const segmentId = converter.bin2dec(segmentIdByteBin);

    return {isInitial, segmentId};
};

const reassembleFrame = (segments) => {
    const isAtomicFrame = segments.length === 1;
    const result = segments.reduce((accumulator, currentValue) => {
        const networkLayer = isAtomicFrame ? getNetworkLayerFrame(currentValue) : getNetworkLayerSegment(currentValue);

        return accumulator + networkLayer;
    }, '');

    return result;
};

// For atomic packet
const getNetworkLayerFrame = (frame) => {
    const frameDataSize = scpUtils.getFrameNetworkLayerSize(frame);
    const result = getNetworkLayer(frame, SCP_BYTES.EXTENDED_ATOMIC_FRAME_NETWORK_LAYER.offset, frameDataSize);

    return result;
};

// For segmented packet
const getNetworkLayerSegment = (frame) => {
    const frameDataSizeByte = scpUtils.getDataFromFrame(frame, SCP_BYTES.NETWORK_LAYER_FRAME_SIZE);
    const frameDataSize = converter.hex2dec(frameDataSizeByte) - SCP_BYTES.EXTENDED_FRAME_SEGMENT_ID.size;

    const result = getNetworkLayer(frame, SCP_BYTES.EXTENDED_SEGMENTED_FRAME_NETWORK_LAYER.offset, frameDataSize);

    return result;
};

const getNetworkLayer = (frame, offset, size) => {
    const result = scpUtils.getDataFromFrame(frame, {
        offset,
        size,
    });

    return result;
};

const isBleExtendedFrame = (frame) => {
    const isExtended = BLE_EXTENDED_FRAME_HEADERS.includes(frame[0]);

    return isExtended;
};

const addHeaderToBleAtomicFrame = (frame) => {
    if (frame.startsWith(BLE_ATOMIC_FRAME_HEADER)) return frame;
    const result = `${BLE_ATOMIC_FRAME_HEADER}${frame}`;

    return result;
};

const removeHeaderFromBleExtendedFrame = (frame) => {
    if (!frame.startsWith(BLE_ATOMIC_FRAME_HEADER)) return frame;

    const result = frame.replace(BLE_ATOMIC_FRAME_HEADER, '');

    return result;
};

export default {
    addHeadersToAtomicFrame,
    addHeaderToBleAtomicFrame,
    getNetworkLayer,
    getNetworkLayerFrame,
    getNetworkLayerSegment,
    getNetworkLayerSize,
    getSegmentIdByte,
    getSegmentIdFromSegment,
    isBleExtendedFrame,
    isExtendedFrame,
    isExtendedSegmentedFrame,
    isSegmentedFrameReportId,
    reassembleFrame,
    removeHeaderFromBleExtendedFrame,
    segmentFrame,
};
